import { cn } from "@util/helpers";

export const WHATSAPP_URL = "https://api.whatsapp.com/send?text=";

export const COMMON_BUTTON_CSS =
  "flex cursor-pointer items-center justify-center whitespace-nowrap rounded-full border border-solid border-gray-175 text-center !font-poppins text-gray-850 transition-all duration-150 hover:border-gray-850 data-[size=lg]:h-[68px] data-[size=md]:h-[42px] data-[size=sm]:h-[36px] data-[size=xs]:h-[24px] font-semibold text-xs tracking-[0.02em]";

export const REMOVE_FOCUS_CSS =
  "!outline-none focus-within:outline-none focus:outline-none outline-0 focus-within:outline-0 focus:outline-0";

export const btnPrimaryCss = cn(
  "font-poppins text-white text-2xs px-6 py-3 bg-orange-300 hover:bg-[#ED8604]"
);

export const btnSecondaryCss = cn(
  "font-poppins text-gray-850 text-xs px-6 py-3 border border-gray-175 hover:border-gray-850 rounded-full tracking-[0.02em]"
);

export const btnLinkCss = cn(
  "font-poppins !text-gray-850 text-base font-semibold leading-[150%] hover:text-gray-850 hover:underline hover:underline-offset-4 flex tracking-[0.02em]"
);
